import { useState } from "react";
import { deleteTemplate } from "../../_services/form_template.service";
import { alertError } from "../../_utils/alerts";

export const useDeleteTemplate = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleDeleteTemplate = async (id, callback) => {
    setLoading(true);
    try {
      const response = await deleteTemplate(id);
      setData(response);
      if (callback) callback();
    } catch (error) {
      console.error("Error deleting template:", error);
      alertError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, handleDeleteTemplate };
};
